import { PrintArea, ProductType } from '@/types';
import { assertDefined } from '@/utils/assertDefined';
import { getView } from './getView';

export const getViewForPrintArea = (productType: ProductType, printArea: PrintArea) =>
  assertDefined(getView(productType, printArea.defaultView.id));
